import React from 'react';
import ReactDOM from 'react-dom/client';
import '@cloudscape-design/global-styles/index.css';
import App from './App';

// Suppress benign ResizeObserver loop error (common with Cloudscape components).
// Must use capture phase + stopImmediatePropagation to beat webpack-dev-server's overlay.
const resizeObserverErr = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (e.message && resizeObserverErr.test(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true);

// Also patch the global onerror to catch it before WDS overlay registers
const origOnError = window.onerror;
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && resizeObserverErr.test(message)) {
    return true; // swallow
  }
  return origOnError ? origOnError(message, ...args) : false;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
